import axios, { AxiosRequestConfig } from "axios";
import _ from "lodash";

const config = {
  baseURL: process.env.REACT_APP_API_URL,
  validateStatus: (status) => status < 500,
  params: {},
} as AxiosRequestConfig;

const http = axios.create(config);
http.interceptors.request.use(
  async function (req) {
    const headers:any = _.clone(req.headers);
    headers.common["Content-Type"] = "application/json";
    headers.common["Accept"] = "application/json";

    headers.common["Access-Control-Allow-Origin"] = "*";
    headers.common["Access-Control-Allow-Credentials"] = "true";

    req.headers = headers;

    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

http.interceptors.response.use(
  function (res) {
    if (res.status !== 200 && res.status !== 201 && res.status !== 204) {
      throw res;
    }
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);


export const GetReq = (url: string) => {
  return  http.get(url);
};

export const PostReq = (url: string, data: any, requestConfig?: AxiosRequestConfig) => {
  return  http.post(url, data, requestConfig);
};

export const PutReq = (url: string, data: any) => {
  return http.put(url, data);
};

export const DeleteReq = async (url: string, data: any) => {
  return http.delete(url, data);
};


